import { MDBBtn, MDBBtnGroup, MDBCheckbox, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBIcon, MDBModalFooter, MDBSpinner, MDBTable, MDBTableBody, MDBTextArea } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { editIntegrations, getMisc, setMultiSelectField } from "../../../apiclients/streamsapi_bridge";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { getMultiSelectRequest, setMultiSelectValue } from "../misc/MultiSelectRequest";
import { getStreamsProductName } from "../../../apiclients/CommonUtils";
import PopupLoader from "../PopupLoader";

const AddWIEvents = (props) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [eventList, seteventList] = useState([]);
  const [eventTypes, seteventTypes] = useState([]);
  const [allowURLKeys, setallowURLKeys] = useState(true);
  const [eventUniqueId, seteventUniqueId] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [eventTextValue, seteventTextValue] = useState("");
  const [warningMsg, setwarningMsg] = useState([]);
  const streamsProductName = getStreamsProductName();
  const [addMsgPopUp, setAddMsgPopUp] = useState(false);
  const [logInOutFlag, setLogInOutFlag] = useState(false);
  const togglePopUp = () => setAddMsgPopUp(!addMsgPopUp)
  const { register, handleSubmit, reset, watch, setValue, formState: { isDirty, dirtyFields, errors }, control, clearErrors, setError } = useForm({
    defaultValues: {
      web_integration: {
        event_id: -1,
        url: "",
        ip_phone1: true,
        ip_phone2: true,
        streams_desktop: true,
        streams_mobile: true,
        browser_type: "New Tab",
        // browser_text: "",
      }
    }
  })

  useEffect(() => {
    if (props.agentList && props.agentList.length > 0) {
      validateWebIntegration();
    }

  }, [props.agentList]);
  async function validateWebIntegration() {
    const tdata = await setMultiSelectValue(8, "", props.agentList, props.moduleType);
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("validateWebIntegration for multi select ::::::::::::: " + JSON.stringify(tdata));
    const reponseMsg = tdata?.display_info?.message ?? [];
    if (reponseMsg.length > 0) {
      setwarningMsg(reponseMsg);
    }

  }

  async function fetchEventTypes() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["event_types"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    console.log(tdata);
    if (!tdata) {
      window.alert(`info with id  not found`);
    }
    // As a part of hiding the events that contains ACD in web integration we are creating tdataNew that does not contain ACD events
    let tdataNew = tdata?.misc?.event_types.filter((eachEvent) => !eachEvent.event.includes("ACD"));
    console.log(tdataNew)
    seteventList(tdataNew ?? []);


  }
  useEffect(() => {
    if (props.eventDetails && Object.keys(props.eventDetails).length > 0) {
      const web_integration = {
        event_id: parseInt(props?.eventDetails?.event_id ?? 1),
        url: props.eventDetails.url,
        ip_phone1: props.eventDetails.ip_phone1,
        ip_phone2: props.eventDetails.ip_phone2,
        streams_desktop: props.eventDetails.streams_desktop,
        streams_mobile: props.eventDetails.streams_mobile,
        browser_type: props.eventDetails.browser_type,
        // browser_text: props.eventDetails.browser_text,
      }
      reset({ web_integration: web_integration });
      seteventUniqueId(props?.eventDetails?.event_unique_id ?? "");
      if (props?.eventDetails?.event_id === 15 || props?.eventDetails?.event_id === 16) {
        setLogInOutFlag(true);
      }

    }

  }, [props.eventDetails]);

  async function fetchURLKeys(eventid) {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["event_keys"], eventid: parseInt(eventid) }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    console.log(tdata);
    if (!tdata) {
      window.alert(`info with id  not found`);
    }
    seteventTypes(tdata?.misc?.event_keys ?? []);




  }

  async function fetchURL(eventid) {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["geturl"], eventid: parseInt(watch("event_id")) }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    console.log(tdata);
    if (!tdata) {
      window.alert(`info with id  not found`);
    }
    setValue("web_integration.url", tdata.misc.url ?? "", { shouldDirty: true });


  }

  async function addEventType(e) {
    setIsloading(true);
    handleSubmit(onSubmit)();
    setAddMsgPopUp(false);
  }

  useEffect(() => {
    fetchEventTypes();
  }, []);

  useEffect(() => {
    if (allowURLKeys);
    fetchURLKeys(props?.eventDetails?.event_id ?? -1);
    setallowURLKeys(false);

  }, [allowURLKeys]);

  async function onSubmit(data, flag) {
    if (flag) {
      setAddMsgPopUp(true);
      return;
    }
    let update = {};
    if (eventUniqueId !== "") {
      let modifiedFields = {};
      if (isDirty) {
        const fieldKeys = dirtyFields.web_integration;
        const fieldData = data.web_integration;
        Object.entries(fieldKeys).forEach(([key, value]) => {
          modifiedFields[key] = fieldData[key];
        });

        if (Object.keys(modifiedFields).length > 0) {
          if (!modifiedFields.event_id) {
            modifiedFields.event_id = fieldData.event_id;
          }
          modifiedFields.event_unique_id = parseInt(eventUniqueId);
          update = {
            web_integration: modifiedFields,
          }
          // update.event_unique_id = parseInt(eventUniqueId);
        }


      }

    } else {
      update = {
        web_integration: {
          event_id: data.web_integration.event_id,
          url: data.web_integration.url,
          ip_phone1: data.web_integration.ip_phone1,
          ip_phone2: data.web_integration.ip_phone2,
          streams_desktop: data.web_integration.streams_desktop,
          streams_mobile: data.web_integration.streams_mobile,
          browser_type: data.web_integration.browser_type,
        }
      }
      if (data.web_integration.event_id === 15 || data.web_integration.event_id === 16) {
        update.web_integration.ip_phone1 = false;
        update.web_integration.ip_phone2 = false;
        update.web_integration.streams_mobile = false;
      }
      // if (data.web_integration.browser_type === "current") {
      //   update.web_integration.browser_text = data.web_integration.browser_text;
      // }

    }

    if (Object.keys(update).length > 0) {
      update.reqid = 69;
      update.siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      if(props.submitFlag) {
        update.agentid = props.useragent;
      } else {
        update.uniqueids = props.useragent;
        update.module_type = props?.moduleType ?? null;
      }

    }

    console.log("final request is  :::::::::: " + JSON.stringify(update));
    setIsloading(true);
    let saverep = await editIntegrations(update);
    console.log(`reponse of Edit integration:::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of modified data :::" + JSON.stringify(saverepeMsg)
    );
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      props.setSuccessMessage(saverepeMsg.message);

      const web_integration = {
        event_id: data.web_integration.event_id,
        url: data.web_integration.url,
        ip_phone1: data.web_integration.ip_phone1,
        ip_phone2: data.web_integration.ip_phone2,
        streams_desktop: data.web_integration.streams_desktop,
        streams_mobile: data.web_integration.streams_mobile,
        browser_type: data.web_integration.browser_type,
        is_active: true
      }
      // if (data.web_integration.browser_type === "current") {
      //   web_integration.browser_text = data.web_integration.browser_text;
      // }
      if (eventUniqueId === "") {
        web_integration.event_unique_id = saverepeMsg?.event_unique_id ?? "";
        web_integration.event_type = eventTextValue;
        props.setisAdd(true);

      } else {
        web_integration.event_unique_id = eventUniqueId;
        web_integration.event_type = props.eventDetails.event_type;
        props.setisEdit(true);

      }
      props.setnewEventObj(web_integration);
      props.onClose();


    } else {
      if (saverepeMsg.message?.errors) {
        saverepeMsg.message.errors.forEach((errorGroup) => {
          if (errorGroup.errors) {
            errorGroup.errors.forEach((err) => {
              setError(err.param_name, {
                type: "server",
                message: err.message,
              });
              const fieldElement = document.querySelector(
                `input[name="${err.param_name}"]`
              );
              if (fieldElement) {
                fieldElement.focus();
                fieldElement.scrollIntoView({ behavior: "smooth" });
              }
            });
          }
        });
      }
    }

  }

  async function onUserMultiSelectSubmit(data) {

    let update = {};
    update = {
      web_integration: {
        event_id: data.web_integration.event_id,
        url: data.web_integration.url,
        ip_phone1: data.web_integration.ip_phone1,
        ip_phone2: data.web_integration.ip_phone2,
        streams_desktop: data.web_integration.streams_desktop,
        streams_mobile: data.web_integration.streams_mobile,
        browser_type: data.web_integration.browser_type,
      }
    }
    if (Object.keys(update).length > 0) {
      update.reqid = 90;
      update.siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      update.agentids = props.agentList;
      update.save_flag = 1;
      update.option_type = 8;
    }

    console.log("final request is  :::::::::: " + JSON.stringify(update));
    setIsloading(true);
    let saverep = await setMultiSelectField(update);
    // debugger;
    console.log(`reponse onUserMultiSelectSubmit:::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of modified data :::" + JSON.stringify(saverepeMsg)
    );
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    if (saverepeMsg.status == "Failed") {
      localStorage.setItem(
        "user_create_f",
        "Something went wrong, Please try again after sometime"
      );
      props.onClose();
      window.location.href = "/userlanding";
    } else {
      console.log("roleid for multi select ::::::::::::: " + JSON.stringify(saverepeMsg));
      localStorage.setItem("s_message", saverepeMsg.message);

      if (props.locUser) {
        navigate("/locationsusers", {
          state: { tab: props.locUser },
        });

      } else if (props.groupInfo) {
        navigate("/usersgroups", {
          state: { tab: props.groupInfo },
        });

      } else if (props.groupUInfo) {
        navigate("/SelectedUserGroupSettings", {
          state: { tab: "tab2", groupUInfo: props.groupUInfo },
        });
      } else if (props.usergroups) {
        navigate("/userlanding", {
          state: { tab: "mgroups" },
        });

      } else if (props.userLoc) {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "sloc" },
        });

      } else if (props.userAllgroups) {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "sgroups" },
        });



      } else {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "suser" },
        });
      }
      props.onClose();

      window.location.reload();
    }

  }

  const checkSubmit = (data) => {
    const hasRecords = props.recordList?.length > 0;
    const isDuplicate = hasRecords && props.recordList.some(
      (item) => item.event_id === data.web_integration.event_id
    );
    onSubmit(data, isDuplicate ? 1 : undefined);
  };

  return (
    <>
      <div>
        {warningMsg && warningMsg.length > 0 && warningMsg.map((meg) => (
          <div className="pt-2 phrecording">
            {meg}
          </div>
        ))}
        <div className="w-100">
          <strong className=" mt-2 d-block">{t("EVENT")}</strong>
          <span className="phrecording w-100">{t("PermissionRoletxt")}</span>
          <Controller
            name="web_integration.event_id"
            control={control}
            rules={{
              validate: (value) => value !== -1 || "Event is required"
            }}

            render={({ field }) => (
              <select
                disabled={Object.keys(props.eventDetails).length > 0}
                className="form-select form-control mt-2 w-100"
                name=""
                value={parseInt(watch("web_integration.event_id"))}
                onChange={(e) => {
                  e.preventDefault();
                  clearErrors("web_integration.event_id");
                  setValue("web_integration.event_id", parseInt(e.target.value), { shouldDirty: true });
                  if (e.target.value === "15" || e.target.value === "16") {
                    setLogInOutFlag(true);
                  } else {
                    setLogInOutFlag(false);
                  }
                  seteventTextValue(e.target.options[e.target.selectedIndex].text);
                  fetchURLKeys(e.target.value);

                }}
              >
                <option value={-1}>Select Event Type</option>
                {eventList && eventList.map(events => (
                  <option value={events.eventid}>{events.event}</option>
                ))}
              </select>
            )}
          />
          {errors?.web_integration?.event_id && (
            <p className="text-danger">{errors?.web_integration?.event_id?.message}</p>
          )}
        </div>
        <br />
        <div className="w-100">
          <strong className=" mt-2 d-block">{t("URL")}</strong>
          {/* <span className="phrecording w-100">
            {t("StreamsACDCall3rdpartywebapp", {"PRODUCT_NAME" : streamsProductName})}
          </span> */}
          <select
            className="form-select form-control mt-2 w-100"
            name=""
          // onClick={(e) => {
          //   e.preventDefault();
          //   fetchURL();
          // }}
          >
            {/* <option value="San Jose">Streams ACD Call Disposition</option> */}
            <option value="San Jose">3rd party Web application</option>

          </select>
        </div>
        <div className="mt-2 add-numbermain">
          <Controller
            name="web_integration.url"
            control={control}
            rules={{
              required: "URL is required.",
              pattern: {
                // value: /^(https?|ftp):\/\/(([\w.-]+|\d{1,3}(\.\d{1,3}){3}))(:\d{1,5})?(\/[\w.-]*)*(\?[\w=&%.$-]*)?(#[\w-]*)?$|^www\.[\w.-]+(\/[\w.-]*)*(\?[\w=&%.$-]*)?(#[\w-]*)?$/,
                /* This regex is used to validate RFC-compliant URLs including:
                 * - HTTP, HTTPS, FTP, and custom schemes
                 * - IPv4 and IPv6 addresses
                 * - Userinfo (username:password@)
                 * - Domains, paths, query strings, fragments
                 * - www URLs without scheme 
                 * - accepts any combination / number of "#" after domain
                */
                value: /^(?:(?:[A-Za-z][A-Za-z0-9+.-]*:)?\/\/(?:[^@\s]+@)?(?:(?:[A-Za-z0-9-]+\.)*[A-Za-z0-9-]+|(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])|\[[0-9A-Fa-f:.]+\]))[^\s]*$|^www\.[^\s]+$/,
                message: "Invalid URL format."
              }
            }}

            render={({ field }) => (
              <MDBTextArea
                name="web_integration.url"
                value={watch("web_integration.url")}
                onChange={(e) => {
                  e.preventDefault();
                  setValue("web_integration.url", e.target.value, { shouldDirty: true });
                  clearErrors("web_integration.url");
                }}
                rows={4}
                style={{ fontSize: "10px" }}
              />
            )}
          />
          <MDBBtnGroup
            aria-label="Button group with nested dropdown"
            className="display-inline float-right mx-3"
          >
            <MDBDropdown>
              <MDBDropdownToggle className="btn btn-primary green-button no-shadow">
                <MDBIcon fas icon="plus" size="sm" /> {t("AddURLKey")}
              </MDBDropdownToggle>
              <MDBDropdownMenu className="dropdown-animi">
                {eventTypes && eventTypes.map(type => (
                  <MDBDropdownItem onClick={(e) => setValue("web_integration.url", watch("web_integration.url") + "$" + type + "$", { shouldDirty: true })} link>{type}</MDBDropdownItem>
                ))}
              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBBtnGroup>
        </div>
        {errors?.web_integration?.url && (
          <p className="text-danger">{errors?.web_integration?.url?.message}</p>
        )}

        {logInOutFlag && <>
          <strong className=" mt-2 d-block">{t("Devicesapplyinteg")}</strong>
          {/* {!logInOutFlag &&
          <>
            <div className="add-numbermain mt-2">
          <div>
            <div className="tel-numbers">{t("IpPhone")} 1</div>
          </div>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" {...register("web_integration.ip_phone1")} type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        <div className="add-numbermain mt-2">
          <div>
            <div className="tel-numbers">{t("IpPhone")} 2</div>
          </div>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" {...register("web_integration.ip_phone2")} type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        <div className="add-numbermain mt-2">
          <div>
            <div className="tel-numbers">{t("StreamsMobile", {"PRODUCT_NAME" : streamsProductName})}</div>
          </div>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control" {...register("web_integration.streams_mobile")} type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
          </>
        } */}

          <div className="add-numbermain mt-2">
            <div>
              <div className="tel-numbers">{t("StreamsDesktop", { "PRODUCT_NAME": streamsProductName })}</div>
            </div>
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" {...register("web_integration.streams_desktop")} type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </>
        }

        <strong className=" mt-2 d-block">{t("BrowserBehaviour")}</strong>
        <MDBTable className="w-100 mb-4">
          <MDBTableBody>
            <tr>
              <td>
                <MDBCheckbox
                  name="flexCheck1"
                  value="New Tab"
                  className="me-0"
                  checked={watch("web_integration.browser_type") === "New Tab"}
                  id="flexCheckDefault"
                  label="New Tab"
                  // defaultChecked
                  onChange={(e) => setValue("web_integration.browser_type", "New Tab", { shouldDirty: true })}
                />
              </td>
            </tr>
            <tr>
              <td>
                <MDBCheckbox
                  name="flexCheck2"
                  value="Current Tab"
                  checked={watch("web_integration.browser_type") === "Current Tab"}
                  className="me-0"
                  id="flexCheckDefault2"
                  label="Current Tab"
                  onChange={(e) => setValue("web_integration.browser_type", "Current Tab", { shouldDirty: true })}
                />
              </td>
              {/* {(watch("web_integration.browser_type") !== "new" && watch("web_integration.browser_type") !== "invisible") && (
                <td>
                  <input type="text" {...register("web_integration.browser_type", { required: "browser type is required" })} />
                  {errors?.web_integration?.browser_text && (
                    <p className="text-danger">{errors?.web_integration?.browser_text?.message}</p>
                  )}
                </td>
              )} */}
            </tr>
            <tr>
              <td>
                <MDBCheckbox
                  name="flexCheck3"
                  value="No Browser"
                  className="me-0"
                  checked={watch("web_integration.browser_type") === "No Browser"}
                  id="flexCheckDefault3"
                  label="No Browser"
                  onChange={(e) => setValue("web_integration.browser_type", e.target.checked ? "No Browser" : "", { shouldDirty: true })}
                />
              </td>
            </tr>
          </MDBTableBody>
        </MDBTable>
      </div>
      <MDBModalFooter>
        <MDBBtn onClick={(e) => props.onClose(e)} color="secondary">
          {t("close")}
        </MDBBtn>
        {Object.keys(props.eventDetails).length > 0 ? (Object.keys(dirtyFields).length > 0 ? (
          <MDBBtn onClick={(e) => {
            e.preventDefault();
            handleSubmit(onSubmit)();
          }} color="primary">
            {t("save")}
          </MDBBtn>
        ) : null
        ) : (props?.agentList && props?.agentList?.length > 0) ? (
          <MDBBtn onClick={(e) => {
            e.preventDefault();
            handleSubmit(onUserMultiSelectSubmit)();
          }} color="primary">
            {t("add")}
          </MDBBtn>

        ) : (
          <MDBBtn onClick={(e) => {
            e.preventDefault();
            if (props.submitFlag) {
              handleSubmit(checkSubmit)();
            } else {
              handleSubmit(onSubmit)();
            }
          }} color="primary">
            {t("add")}
          </MDBBtn>
        )}
        {addMsgPopUp && (
          <PopupLoader
            title={t("alert")}
            content={
              <>
                <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                  <MDBIcon fas icon="exclamation-triangle" color="warning" className="me-3 fs-5 mt-1" />
                  <div>{t("WebIntWarnMsg")}</div>
                </div>
                <MDBModalFooter className="mt-2 pb-0 px-0">
                  <MDBBtn color="secondary" onClick={togglePopUp}>
                    {t("cancel")}
                  </MDBBtn>
                  <MDBBtn onClick={(e) => addEventType(e)}>{t("Ok")}</MDBBtn>
                </MDBModalFooter>
              </>
            }
            onShow={setAddMsgPopUp}
            onClose={togglePopUp}
          />
        )}
      </MDBModalFooter>
      {
        isloading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                Loading...
              </MDBBtn>
            </div>
          </>
        )
      }
    </>
  );
};

export default AddWIEvents;
